import { ComponentPropsWithRef } from 'react';

export type ButtonProps = ComponentPropsWithRef<'button'>;

export const Button = (props: ButtonProps) => (
  <button {...props} />
);
